import landingPageService, { ENDPOINTS } from '@/services/landingPageService';
import moduleFactory from '@/store/modules/moduleFactory';

const moduleStore = moduleFactory.build(ENDPOINTS, landingPageService);

export default {
    namespaced: true,
    state: {
        ...moduleStore.state,
    },
    getters: {
        ...moduleStore.getters,
    },
    mutations: {
        ...moduleStore.mutations,
    },
    actions: {
        ...moduleStore.actions,
    },
};
